/**
 * @file 展开路由params参数,并于原props合并 即 {...props, ...props.match.params}
 * @author tanghui03
 */

import {compose, mapProps} from 'recompose';

export default compose(mapProps(props => {
    const params = props.match.params;
    const paramsKeysSet = new Set(Object.keys(params));
    const propsKeysArray = Object.keys(props);
    const hasIntersection = propsKeysArray.some(key => paramsKeysSet.has(key));

    if (hasIntersection) {
        const intersection = propsKeysArray.filter(key => paramsKeysSet.has(key));
        throw new Error(`Duplication of attribute key exists between props and params: '${intersection.join(',')}'`);
    }

    return {...props, ...params};
}));
